// extracted by mini-css-extract-plugin
module.exports = {"App":"_1o-FpbQrR11SDFN-G7O4U3"};